import * as React from 'react';
import { FC } from 'react';

interface SparkleAIIconProps {
    style?: React.CSSProperties;
}

const SparkleAIIcon: FC<SparkleAIIconProps> = ({ style }) => (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" style={style}>
        <path d="M17.5 2c-.28 0-.5.22-.5.5 0 1.38-.62 2.62-1.6 3.47C14.46 6.82 13.2 7.5 11.5 7.5c-.28 0-.5.22-.5.5s.22.5.5.5c1.7 0 2.96.68 3.9 1.53C16.38 10.88 17 12.12 17 13.5c0 .28.22.5.5.5s.5-.22.5-.5c0-1.38.62-2.62 1.6-3.47C20.54 9.18 21.8 8.5 23.5 8.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5c-1.7 0-2.96-.68-3.9-1.53C18.62 5.12 18 3.88 18 2.5c0-.28-.22-.5-.5-.5z"/>
        <path d="M8 13c-.2 0-.37.16-.37.37 0 1.02-.46 1.94-1.19 2.57C5.71 16.57 4.8 17 3.63 17c-.2 0-.37.16-.37.37s.16.37.37.37c1.17 0 2.08.43 2.81 1.06.73.63 1.19 1.55 1.19 2.57 0 .2.16.37.37.37s.37-.16.37-.37c0-1.02.46-1.94 1.19-2.57.73-.63 1.64-1.06 2.81-1.06.2 0 .37-.16.37-.37S12.97 17 12.77 17c-1.17 0-2.08-.43-2.81-1.06-.73-.63-1.19-1.55-1.19-2.57C8.77 13.16 8.2 13 8 13z"/>
        <path d="M4.5 4c-.17 0-.3.13-.3.3 0 .76-.34 1.44-.88 1.9C2.78 6.67 2.1 7 1.3 7c-.17 0-.3.13-.3.3s.13.3.3.3c.8 0 1.48.33 2.02.8.54.46.88 1.14.88 1.9 0 .17.13.3.3.3s.3-.13.3-.3c0-.76.34-1.44.88-1.9.54-.47 1.22-.8 2.02-.8.17 0 .3-.13.3-.3S7.87 7 7.7 7c-.8 0-1.48-.33-2.02-.8-.54-.46-.88-1.14-.88-1.9C4.8 4.13 4.67 4 4.5 4z"/>
    </svg>
);

export default SparkleAIIcon;
